module.exports = __webpack_public_path__ + "img/result.2586cb78.svg";